import styled, {css} from "styled-components";

// BASE BUTTON
export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
  transition-property: background-color, color, padding-right;
  transition-duration: 0.2s;
  border: none;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);

  h6, p {
    font-weight: 500;
  }
`

// BlUE BUTTON
export const BlueButton = styled(Button)`
  background-color: var(--color-blue);
  border: 2px solid transparent;
  display: flex;
  justify-content: space-between;

  h6, p {
    color: var(--color-white);
    flex-grow: 1;
  }

  &:hover {
    background: var(--color-white);
    border-color: var(--color-blue);

    h6, p {
      color: var(--color-blue);
    }
  }
`

export const BlueReverseButton = styled(Button)`
  background-color: transparent;
  border: 2px solid var(--color-blue);

  p {
    color: var(--color-blue);
    flex-grow: 1;
    font-weight: 600;
  }

  &:hover {
    background-color: var(--color-blue);

    h6, p {
      color: var(--color-white)
    }

  }
`


//GREEN BUTTON
export const GreenButton = styled(Button)`
  background-color: var(--color-green-darker);
  box-shadow: 1px 1px 4px rgba(166, 172, 181, 0.6);
  height: 2.5rem;

  &:hover {
    background-color: var(--color-green-06);
  }

  h6, p {
    color: var(--color-white);
  }
`

export const ButtonInProjectCard = styled(BlueButton)`
  display: flex;
  justify-content: space-between;
  width: 18rem;
  height: 2.5em;
  p {
    flex-grow: 1;
    padding-right: 1em;
    color: var(--color-white);
    font-weight: 500;
  }

  svg {
    margin-left: 1em;
  }
`

export const RedButton = styled(Button)`
  background-color: var(--color-red);

  p {
    color: var(--color-white)
  }

  &:hover {
    background-color: var(--color-white);
    border: 3px solid var(--color-red);

    h6, p {
      color: var(--color-red)
    }

    svg {
      circle {
        fill: none;
      }

      path {
        fill: var(--color-red);
      }
    }
  }
`

export const RedButtonReverse = styled(Button)`
  background-color: var(--color-white);
  border: 3px solid var(--color-red);

  p {
    color: var(--color-red)
  }

  &:hover {
    background-color: var(--color-red);

    h6, p {
      color: var(--color-white)
    }

    svg {
      circle {
        fill: none;
      }

      path {
        fill: var(--color-white);
      }
    }
  }
`

export const PurpleReverseButton = styled(Button)`
  border: 3px solid var(--color-purple);
  padding: 0.5rem;
  background-color: transparent;
  height: 3rem;

  p, h6 {
    color: var(--color-purple);
    flex-grow: 1.5;
  }

  &:hover {
    background-color: var(--color-purple);

    h6, p {
      color: var(--color-white)
    }

    svg {
      circle {
        fill: none;
      }

      path {
        fill: var(--color-white);
      }
    }
  }
`

export const GreyButton = styled(Button)`
  align-items: center;
  gap: 0.5em;
  padding: 0.5em;
  border-radius: 10px;
  width: 100%;
  background-color: transparent;

  &:hover {
    background-color: var(--color-grey-03);
  }

  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          background-color: var(--color-grey-03)`;
      default:
        return css`
          background-color: transparent;
        `;
    }
  }}
`